import React, { useState, useEffect } from "react";
import { css } from "emotion";
import { stepContent, header, singleInput } from "../../style";
import SeeMore from "../../../shared/SeeMore";
import { useNewOfferMobile } from "../../../context";
import InputForm from "../../../../../../shared/atoms/InputForm";

const CreditCardNameInput = ({ step, creditCardData, onChangeCreditCardData }) => {
	const { setStepError } = useNewOfferMobile();

	const [state, setState] = useState({
		holderName: creditCardData.data.holderName || "",
		hasError: false
	});

	useEffect(() => {
		setStepError(!state.holderName.length);
	}, [state]);

	const onChange = event => {
		const { name, value } = event.target;
		const holderName = String(value).replace(/[0-9]/g, "");

		setState({
			...state,
			[name]: holderName,
			hasError: !holderName.length
		});

		onChangeCreditCardData({ holderName: holderName });
	};

	return (
		<div
			className={css`
                ${stepContent};
            `}
		>
			<strong
				className={css`
                    ${header};
                `}
			>
				Dados do cartão             
			</strong>
			<div
				className={css`
                    ${singleInput};
                `}
			>
				<InputForm
					name="holderName"
					id="holderName"
					value={state.holderName}
					onChange={onChange}
					label="Nome (como está no cartão)"
					errorMessage="Este nome não é o mesmo do cartão"
					maxLength={150}
					hasError={state.hasError}
					data-action="register-credit-card-name"
				/>
			</div>

			<SeeMore>
				<strong>Por que precisamos dos dados do seu cartão?</strong>
				<p>
					Para emitir passagens em companhias internacionais, o pagamento das taxas e encargos deve
					ser feito no cartão de crédito do mesmo titular das milhas.                 
				</p>

				<p>Por isso, cadastre os dados corretos do cartão.</p>

				<p>
					<strong>Sigilo e segurança dos seus dados</strong>
				</p>

				<p>
					Vale sempre lembrar que nossa plataforma é blindada e tem certificação de excelência em
					segurança. Aqui, seus dados estão protegidos.
				</p>
			</SeeMore>
		</div>
	);
};

export default CreditCardNameInput;
